import {convertSlideIndexToUUID} from "../utils/convert-slide-data";


function fixJSON(data) {
    if (data.slides) {
        data.slides.forEach(slide => {
            if (slide.cameraSm) {
                slide.camera.sizeSm = slide.cameraSm;
                delete slide.cameraSm;
            }

            slide.background = slide.background || { type: "none", value: null };
            slide.background.value = slide.background.value || { color: null, image: null, video: null };

            slide.background.value.color = slide.background.value.color || { primary: "#b1cfcf", secondary: "#7f7f7f", gradient: null };
            slide.background.value.color.gradient = slide.background.value.color.gradient || { enabled: false, style: "solid" };

            slide.background.value.image = slide.background.value.image || { texture: null, textureMobile: null, offset: null, scale: null };
            slide.background.value.image.offset = slide.background.value.image.offset || { x: 0, y: 0 };
            slide.background.value.image.scale = slide.background.value.image.scale || { x: 1, y: 1 };

            slide.background.value.fitMode = slide.background.value.fitMode || 'cover';

            if ("backgroundGradientEnabled" in slide) slide.background.value.color.gradient.enabled = slide.backgroundGradientEnabled;
            if ("backgroundGradientStyle" in slide) slide.background.value.color.gradient.style = slide.backgroundGradientStyle;

            if ("backgroundType" in slide) slide.background.type = slide.backgroundType;
            if ("backgroundValue" in slide) {

                switch (slide.background.type) {
                    case "color": slide.background.value.color.primary = slide.backgroundValue; break;
                    case "image":
                    case "panorama": slide.background.value.image.texture = slide.backgroundValue; break;
                    case "video": slide.background.value.video = slide.backgroundValue; break;
                }
            }

            if ("backgroundMobileValue" in slide) slide.background.value.image.textureMobile = slide.backgroundMobileValue;
            if ("backgroundValueSecondary" in slide) slide.background.value.color.secondary = slide.backgroundValueSecondary;

            if ("backgroundOffsetX" in slide) slide.background.value.image.offset.x = slide.backgroundOffsetX;
            if ("backgroundOffsetY" in slide) slide.background.value.image.offset.y = slide.backgroundOffsetY;
            if ("backgroundScaleX" in slide) slide.background.value.image.scale.x = slide.backgroundScaleX;
            if ("backgroundScaleY" in slide) slide.background.value.image.scale.y = slide.backgroundScaleY;

            delete slide.backgroundGradientEnabled;
            delete slide.backgroundGradientStyle;
            delete slide.backgroundType;
            delete slide.backgroundValue;
            delete slide.backgroundValueSecondary;
            delete slide.backgroundMobileValue;
            delete slide.backgroundOffsetX;
            delete slide.backgroundOffsetY;
            delete slide.backgroundScaleX;
            delete slide.backgroundScaleY;

            slide.background = Object.seal(slide.background);
            slide.background.value = Object.seal(slide.background.value);
            slide.background.value.color = Object.seal(slide.background.value.color);
            slide.background.value.color.gradient = Object.seal(slide.background.value.color.gradient);
            slide.background.value.image = Object.seal(slide.background.value.image);
            slide.background.value.image.offset = Object.seal(slide.background.value.image.offset);
            slide.background.value.image.scale = Object.seal(slide.background.value.image.scale);

            if (slide.slideQuiz) {
                if (slide.slideQuiz.type === "draglabels") {
                    slide.slideQuiz.meshes.reverse().forEach(meshes => {
                        if ("question" in meshes && meshes.length > 0) {
                            slide.slideQuiz.question = meshes.question;
                            delete meshes.question;
                        }
                    });
                } else if (slide.slideQuiz.type === "plopQuiz" && !("slideQuiz" in slide)) {
                    const useSnapping = slide.slideQuiz.meshes.every(({ useSnapping }) => useSnapping);

                    slide.slideQuiz.useSnapping = useSnapping;
                }
            }

            // Refactor slide 'navigate' actions. Use slide uuid instead of index of slides array.
            for (const [uuid, value] of Object.entries(slide.animation).filter(arr => arr[1])) {
                let actions = value.action;
                if (!Array.isArray(actions)) {
                    delete value.action;
                    continue;
                }
                if (!actions) continue;

                actions.forEach(action => {
                    if (action && action.systemAction === 'navigate' && action.value && typeof action.value.slide === 'number' ) {
                        action.value.slide = convertSlideIndexToUUID(action.value.slide, data.slides)
                    }
                });
            }
        });
    }

    if (data.layers && data.layers.layers2D) {
        Object.values(data.layers.layers2D).forEach(lData => {
            if (lData.objects && Object.values(lData.objects)[0] && Object.values(lData.objects)[0].type === "textOld") {
                Object.values(lData.objects)[0].type = "text"
            }
        });
    }

    return data;
}

export default fixJSON;
export { fixJSON };
